var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import generatorForm from "../../generator-form";
import { FormItemTextarea } from "../../../../components/form-item/form-item-textarea/form-item-textarea";
import { FormItemDateRange } from "../../../../components/form-item/form-item-date-range/form-item-date-range";
import { FieldArray, useFormikContext, getIn } from "formik";
import { getPrograms } from "../../generator-utils";
import { FormItemImageUpload } from "../../../../components/form-item/form-item-image-upload/form-item-image-upload";
import { DateFormatType } from "../../generator-enum";
import { FormItemDate } from "../../../../components/form-item/form-item-date/form-item-date";
import { getTooltipText } from "../../generator-tooltips";
import { FormItemRadio } from "../../../../components/form-item/form-item-radio/form-item-radio";
import { FormItemSelect } from "../../../../components/form-item/form-item-select/form-item-select";
import { FormItemDebet } from "../../../../components/form-item/form-item-debet/form-item-debet";
import { ProgramSupportEnum } from "./info-form-enum";
function getStyles(form, fieldName) {
    if (getIn(form.errors, fieldName) && getIn(form.values, fieldName).length > 0) {
        return {
            border: '1px solid red',
            'caret-color': 'red',
        };
    }
}
export var InfoForm = function (_a) {
    var tooltips = _a.tooltips;
    var name = generatorForm.name, goal = generatorForm.goal, sponsorSelect = generatorForm.sponsorSelect, programSupport = generatorForm.programSupport;
    var _b = useFormikContext().values, stepActive = _b.stepActive, program = _b.program, format = _b.format, projects = _b.projects;
    var _c = useFormikContext(), isSubmitting = _c.isSubmitting, setFieldValue = _c.setFieldValue;
    var selectedProgram = getPrograms().find(function (_a) {
        var value = _a.value;
        return value === program;
    });
    var selectedFormatGroup = selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.formatGroups.find(function (_a) {
        var formats = _a.formats;
        return formats.find(function (_a) {
            var formatTypes = _a.formatTypes;
            return formatTypes.find(function (_a) {
                var value = _a.value;
                return value === format;
            });
        });
    });
    var selectedFormat = selectedFormatGroup === null || selectedFormatGroup === void 0 ? void 0 : selectedFormatGroup.formats.find(function (_a) {
        var formatTypes = _a.formatTypes;
        return formatTypes.find(function (_a) {
            var value = _a.value;
            return value === format;
        });
    });
    var selectedFormatType = selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.formatTypes.find(function (_a) {
        var value = _a.value;
        return value === format;
    });
    useEffect(function () {
        if (stepActive) {
            setTimeout(function () {
                var elem = document.getElementsByClassName('scroll_to_error').item(0);
                if (elem !== null && elem !== undefined) {
                    elem.classList.remove("shake-error");
                    elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    elem.classList.add("shake-error");
                }
            }, 150);
            setFieldValue("stepActive", false);
        }
    });
    var newProjectReff = useRef(null);
    var _d = __read(useState(false), 2), newProjectAdded = _d[0], setNewProjectAdded = _d[1];
    useEffect(function () {
        if (newProjectAdded === true) {
            if (newProjectReff !== null)
                newProjectReff.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
            setNewProjectAdded(false);
        }
    }, [newProjectAdded]);
    return (React.createElement(React.Fragment, null, selectedProgram && selectedFormat && selectedFormatType && (React.createElement("div", { className: "info-form" },
        React.createElement("div", { className: "info-form__container" },
            React.createElement("div", { className: "info-form__note" },
                React.createElement("div", { className: "title-label" },
                    selectedProgram.name,
                    selectedProgram.note ? (selectedProgram.separator ? (React.createElement(React.Fragment, null,
                        selectedProgram.separator,
                        " ",
                        selectedProgram.note)) : (React.createElement(React.Fragment, null,
                        " - ",
                        selectedProgram.note))) : (React.createElement(React.Fragment, null)),
                    " - ",
                    selectedFormat.name,
                    selectedFormat.showSize && React.createElement(React.Fragment, null,
                        " - ",
                        selectedFormat.size))),
            React.createElement("div", { className: "info-form__form" },
                React.createElement(FieldArray, { name: "projects", render: function (arrayHelpers) { return (React.createElement(React.Fragment, null,
                        projects.map(function (project, index) { return (React.createElement("div", __assign({ className: "info-form__project" }, (index === projects.length - 1 && { ref: newProjectReff })),
                            selectedFormatType.programSupport && (React.createElement(FormItemSelect, { name: programSupport.name, label: programSupport.label, tooltip: getTooltipText(tooltips, "programSupport", program), options: ProgramSupportEnum })),
                            React.createElement(FormItemTextarea, { style: getStyles(arrayHelpers.form, "projects[" + index + "].name"), name: "projects." + index + ".name", label: name.label, tooltip: getTooltipText(tooltips, "name", program), rows: 3, maxlength: (selectedFormatType.nameLimit ? selectedFormatType.nameLimit : 70) + 1, placeholder: "Maxim\u00E1n\u00ED d\u00E9lka textu je " + (selectedFormatType.nameLimit ? selectedFormatType.nameLimit : 70) + " znak\u016F. N\u00E1zev projektu m\u016F\u017Ee b\u00FDt zkr\u00E1cen tak, aby byl st\u00E1le z\u0159ejm\u00FD jeho obsah." }),
                            selectedFormatType.goalLimit && (React.createElement(FormItemTextarea, { style: getStyles(arrayHelpers.form, "projects[" + index + "].goal"), name: "projects." + index + ".goal", label: goal.label, tooltip: getTooltipText(tooltips, "goal", program), squareButtons: 1, rows: 10, maxlength: (selectedFormatType.goalLimit ? selectedFormatType.goalLimit : 420) + 1, placeholder: "Maxim\u00E1n\u00ED d\u00E9lka textu je " + (selectedFormatType.goalLimit ? selectedFormatType.goalLimit : 420) + " znak\u016F." })),
                            selectedFormat.dateFormat === DateFormatType.Date && (React.createElement(FormItemDateRange, { name: "projects." + index + ".date", label: "Term\u00EDn fyzick\u00E9 realizace projektu", tooltip: getTooltipText(tooltips, "date-range", program), views: ["month", "year"], format: "MM/yyyy", placeholder: "MM/RRRR" })),
                            selectedFormat.dateFormat === DateFormatType.Year && (React.createElement(FormItemDate, { name: "projects." + index + ".year", label: "Term\u00EDn ukon\u010Den\u00ED fyzick\u00E9 realizace projektu", tooltip: getTooltipText(tooltips, "date", program), views: ["year"], format: "yyyy", placeholder: "RRRR" })))); }),
                        projects.length < (selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.maxProjectCount) && (React.createElement("button", { type: "button", className: "info-form__add-project", onClick: function () {
                                var defaultProjectValues = {
                                    name: "",
                                    goal: "",
                                    date: { from: null, to: null },
                                    year: null,
                                };
                                setNewProjectAdded(true);
                                arrayHelpers.push(defaultProjectValues);
                            } }, "+ P\u0159idat dal\u0161\u00ED projekt")))); } }),
                (selectedProgram.fullSponsored || selectedFormatType.showLogo) && (React.createElement("div", { className: "info-form__project" },
                    selectedProgram.fullSponsored && (React.createElement(FormItemRadio, { name: sponsorSelect.name, label: sponsorSelect.label, tooltip: getTooltipText(tooltips, "sponsorSelect", program), options: [
                            { label: "Ano", value: "yes" },
                            { label: "Ne", value: "no" },
                        ], tooltips: tooltips })),
                    selectedFormatType.showLogo && (React.createElement(FormItemImageUpload, { name: "image", label: "Logo \u017Eadate", tooltip: getTooltipText(tooltips, "logo", program), buttonLabel: "Vyberte soubor s logem", buttonRemoveLabel: "Odebrat logo" })))),
                (selectedFormatType.debetFields) && (React.createElement("div", { className: "info-form__project" },
                    React.createElement(FormItemDebet, { name: "debetAll", label: "Celkov\u00E9 zp\u016Fsobil\u00E9 v\u00FDdaje", tooltip: getTooltipText(tooltips, "debetAll", program) }),
                    React.createElement(FormItemDebet, { name: "contributionFund", label: "P\u0159\u00EDsp\u011Bvek Moderniza\u010Dn\u00EDho fondu", tooltip: getTooltipText(tooltips, "contributionFund", program) }),
                    React.createElement(FormItemDebet, { name: "contributionSubject", label: "P\u0159\u00EDsp\u011Bvek p\u0159\u00EDjemce podpory", tooltip: getTooltipText(tooltips, "contributionSubject", program) })))))))));
};
